import styled from "styled-components";

/**
 * 본문 조판.
 *
 * 정적 뉴스레터(src/content/newsletters/posts/*.js)는 이 컴포넌트들만 조합해서
 * 작성한다. Notion에서 가져온 글(NotionBlocks)도 같은 컴포넌트로 그려지므로,
 * 두 경로의 결과물이 구분되지 않는다.
 */

export const H2 = styled.h2`
  margin: 3rem 0 1rem;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.02em;
  color: var(--nl-ink);

  &:first-child {
    margin-top: 0;
  }
`;

export const H3 = styled.h3`
  margin: 2rem 0 0.75rem;
  font-size: 1.0625rem;
  font-weight: 600;
  line-height: 1.55;
  letter-spacing: -0.01em;
  color: var(--nl-ink);
`;

export const P = styled.p`
  margin: 0 0 1.375rem;
  font-size: 1.0625rem;
  line-height: 1.85;
  color: var(--nl-ink-soft);
`;

export const Strong = styled.strong`
  font-weight: 600;
  color: var(--nl-ink);
`;

/** 본문에서 딱 한 군데만. 여러 곳에 쓰면 강조가 사라진다. */
export const Highlight = styled.mark`
  padding: 0.1em 0.15em;
  background: rgba(224, 165, 0, 0.2);
  color: var(--nl-ink);
`;

export const A = styled.a.attrs((props) => ({
  target: props.target || "_blank",
  rel: props.rel || "noreferrer",
}))`
  color: var(--nl-ink);
  text-decoration: underline;
  text-decoration-color: var(--nl-line-strong);
  text-underline-offset: 3px;
  transition: text-decoration-color 0.18s ease;

  &:hover {
    text-decoration-color: var(--nl-accent);
  }

  &:focus-visible {
    outline: 2px solid var(--nl-accent);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const Ul = styled.ul`
  margin: 0 0 1.375rem;
  padding-left: 1.125rem;
`;

export const Ol = styled.ol`
  margin: 0 0 1.375rem;
  padding-left: 1.25rem;
`;

export const Li = styled.li`
  margin-bottom: 0.5rem;
  padding-left: 0.25rem;
  font-size: 1.0625rem;
  line-height: 1.8;
  color: var(--nl-ink-soft);

  &::marker {
    color: var(--nl-ink-mute);
  }
`;

export const Quote = styled.blockquote`
  margin: 2rem 0;
  padding-left: 1.25rem;
  border-left: 2px solid var(--nl-line-strong);
  font-size: 1.125rem;
  line-height: 1.8;
  color: var(--nl-ink);
`;

export const Callout = styled.aside`
  margin: 2rem 0;
  padding: 1.25rem 1.375rem;
  background: var(--nl-surface);
  border-radius: 10px;
  font-size: 0.9375rem;
  line-height: 1.8;
  color: var(--nl-ink-soft);

  > *:last-child {
    margin-bottom: 0;
  }
`;

export const Code = styled.code`
  padding: 0.12em 0.35em;
  background: var(--nl-surface);
  border-radius: 4px;
  font-family: "SFMono-Regular", Consolas, Menlo, monospace;
  font-size: 0.875em;
  color: var(--nl-ink);
`;

export const Pre = styled.pre`
  margin: 0 0 1.5rem;
  padding: 1.125rem 1.25rem;
  overflow-x: auto;
  background: #1f1a12;
  border-radius: 10px;
  color: #f2f0ec;
  font-family: "SFMono-Regular", Consolas, Menlo, monospace;
  font-size: 0.8125rem;
  line-height: 1.7;
`;

export const Divider = styled.hr`
  width: 3rem;
  margin: 2.5rem 0;
  border: 0;
  border-top: 1px solid var(--nl-line-strong);
`;

export const Figure = styled.figure`
  margin: 2rem 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 10px;
  }

  figcaption {
    margin-top: 0.625rem;
    font-size: 0.8125rem;
    line-height: 1.65;
    color: var(--nl-ink-mute);
  }
`;
